<svg
  class="icon icon--{{ color }}"
  [attr.fill]="svgFill"
  [attr.stroke]="svgStroke"
  [style.width]="width + 'px'"
  [style.height]="height + 'px'"
>
  <use attr.xlink:href="/assets/images/svg-icons.svg#{{ name }}"></use>
</svg>
